(function($, undefined) {

	'use strict';
	var tab;

	var showTabContent = function() {
		var t = $(this);
		var id = t.attr('data-id');
		var ctn = t.closest('.all-tabs-outer-ctn');

		if (t.hasClass('selected') || ctn.hasClass('animating')) {
			return;
		} else {
			ctn.addClass('animating');
		}

		ctn.find('.one-tab.selected').removeClass('selected');
		ctn.find('.one-tab[data-id=' + id +']').addClass('selected');

		ctn.find('.one-tab-content.selected').fadeOut(function() {
			$(this).removeClass('selected');
			
			ctn.find('.one-tab-content[data-id=' + id +']').fadeIn(function() {
				$(this).addClass('selected');
				ctn.removeClass('animating');
			});
		});

	};

	var init = function() {
		tab = $('.one-tab');

		tab.click(showTabContent);
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

